// jshint esversion:6
import {
	CLIENT_ID,
	API_KEY,
	AUTHORIZATION
} from './private'
let bungie = (function Bungie() {
	let bungie = {};
	// private variables
	let ACTIVE_TYPE = 0;
	const membershipType = {
		psn: 2,
		xbox: 1,
		blizzard: 4,
		bungie: 254
	};
	let systemDetails = {};
	let MEMBERSHIP_ID = "";
	let lastRoute = "";
	let lastRequestTime = new Date().getTime();
	let badAddresses = {};
	let requestCache = {};
	let localTokens = null;

	bungie.setTokens = function (tokens) {
		localTokens = tokens;
	};

	bungie.validateTokens = function () {
		return new Promise(function (resolve, reject) {
			// console.log(localTokens, localStorage.getItem("bungieAuth"));
			if (localTokens === null && localStorage.getItem("bungieAuth") !== null) {
				localTokens = JSON.parse(localStorage.bungieAuth);
			}
			if (localTokens) {
				// console.log(localTokens.authCode);

				if (localTokens.authCode) {
					resolve(false);
				} else {
					bungie.refreshAccessToken(localTokens).then(resolve);
				}
			} else {
				resolve(false);
			}
		});
	};

	function _request(opts) {
		if (badAddresses[opts.shortRoute]) {
			badAddresses[opts.shortRoute] += 1;
			if (badAddresses[opts.shortRoute] > 6) {
				badAddresses[opts.shortRoute] = 0;
			} else {
				opts.complete(false);
				// opts.incomplete();
				return false;
			}
		}
		if (requestCache[opts.route]) {
			console.info("Used cached data for " + opts.route);
			opts.complete(requestCache[opts.route]);
			return false;
		}
		var currentTime = new Date().getTime();
		if ((lastRoute === opts.shortRoute && currentTime - lastRequestTime >= 800) || lastRoute !== opts.shortRoute) { // make sure not to poll more than once per second for the same type of request
			console.info(`Bungie API Query Route ${opts.route}`, opts.payload);
			lastRoute = opts.shortRoute;
			lastRequestTime = currentTime;
			let r = new XMLHttpRequest();
			let method = "GET";
			if (opts.payload) {
				method = "POST";
			}
			r.open(method, `https://www.bungie.net/${opts.destiny1===true?"d1/":""}Platform${opts.route}`, true);
			r.setRequestHeader('X-API-Key', API_KEY);
			r.setRequestHeader('Authorization', "Bearer " + localTokens.accessToken.value);
			r.onreadystatechange = function () {
				if (r.readyState === 4) {
					if ((this.status >= 200 && this.status < 400) || opts.noerror) {
						let requestResponse = null;
						try {
							requestResponse = JSON.parse(this.response);
						} catch (e) {
							console.error(e);
							opts.complete(false);
							// opts.incomplete();
						}
						if (requestResponse !== null) {
							if (requestResponse.ErrorCode !== 1 && !opts.noerror) {
								console.error(requestResponse);
								badAddresses[opts.shortRoute] = 1;
								opts.complete(false);
								// opts.incomplete();
							} else { // no errors, continue
								requestCache[opts.route] = requestResponse.Response || requestResponse;
								opts.complete(requestResponse.Response || requestResponse, requestResponse);
							}
						}
					} else {
						console.error(this.status, this.response);
						opts.complete(false);
						// opts.incomplete();
					}
				}
			};
			r.onerror = function () {
				console.error("Request Failed to " + opts.route);
				opts.complete(false);
				// opts.incomplete();
			};
			if (method === "POST") {
				r.send(JSON.stringify(opts.payload));
			} else {
				r.send();
			}
		} else {
			setTimeout(function () {
				_request(opts);
			}, 1000);
		}
	}

	function bungiePOST(url, data, useAuth) {
		console.log("BUNGIE POST", url);
		return new Promise(function (resolve) {
			let r = new XMLHttpRequest();
			r.open("POST", url, true);
			if (useAuth && AUTHORIZATION) {
				r.setRequestHeader("Authorization", "Basic " + AUTHORIZATION);
			}
			r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
			r.onreadystatechange = function () {
				if (r.readyState === 4) {
					if (this.status >= 200 && this.status < 400) {
						try {
							resolve(JSON.parse(this.response));
						} catch (e) {
							console.warn(e);
							resolve(false);
						}

					} else {
						console.error("Request Failed to " + url);
						resolve(false);
					}
				}
			};
			r.onerror = function () {
				console.error("Request Failed to " + url);
				resolve(false);
				// opts.complete(false);
				// opts.incomplete();
			};
			r.send(data);
		});
	}
	// find a way to resume code after bungie.net outtages
	bungie.refreshAccessToken = function (tokens) {
		return new Promise(function (resolve) {
			let currentTime = new Date().getTime();
			let url = "https://www.bungie.net/Platform/App/OAuth/Token/";
			if (tokens.accessToken && tokens.accessToken.expires <= currentTime + 60000 && tokens.refreshToken) {
				bungiePOST(url, `client_id=${CLIENT_ID}&grant_type=refresh_token&refresh_token=${tokens.refreshToken.value}`, true).then(function (response) {
					console.log(response);
					if (response) {
						localTokens = {};
						localTokens.membershipId = response.membership_id;
						localTokens.accessToken = {
							value: response.access_token,
							expires: new Date().getTime() + (response.expires_in * 1000),
							added: new Date().getTime()
						};
						localTokens.refreshToken = {
							value: response.refresh_token,
							expires: new Date().getTime() + (response.refresh_expires_in * 1000),
							added: new Date().getTime()
						};
						localStorage.bungieAuth = JSON.stringify(localTokens);
						if (typeof window !== "undefined") {
							if (window.location.href.indexOf("?") > -1) {
								window.location.href = window.location.href.split("?")[0];
							}
						}
						console.log(localStorage.bungieAuth);
						if (typeof window !== "undefined") {
							window.location.reload();
						}
						return false;
					} else {
						setTimeout(function () {
							if (typeof window !== "undefined") {
								window.location.reload();
							}
						}, 120 * 1000);
					}
				});
			} else if (tokens.authCode) {
				console.log(tokens.authCode);
				bungiePOST(url, `client_id=${CLIENT_ID}&grant_type=authorization_code&code=${tokens.authCode}`, true).then(function (response) {
					console.log(response);
					if (response) {
						localTokens = {};
						localTokens.membershipId = response.membership_id;
						localTokens.accessToken = {
							value: response.access_token,
							expires: new Date().getTime() + (response.expires_in * 1000),
							added: new Date().getTime()
						};
						localTokens.refreshToken = {
							value: response.refresh_token,
							expires: new Date().getTime() + (response.refresh_expires_in * 1000),
							added: new Date().getTime()
						};
						localStorage.bungieAuth = JSON.stringify(localTokens);
						if (typeof window !== "undefined") {
							if (window.location.href.indexOf("?") > -1) {
								window.location.href = window.location.href.split("?")[0];
							}
						}
						console.log(localStorage.bungieAuth);
						if (typeof window !== "undefined") {
							window.location.reload();
						}
						return false;
					} else {
						if (typeof window !== "undefined") {
							setTimeout(window.location.reload, 120 * 1000);
						}
					}
				});
			} else if (!tokens || !tokens.accessToken || tokens.accessToken.expires <= currentTime + 60000) { // simulate one minute ahead so we can refresh this token before it expires, hopefully
				localStorage.removeItem("bungieAuth");
				localStorage.removeItem("auth");
				// if (chrome && chrome.identity) {
				// 	chrome.identity.launchWebAuthFlow({
				// 			'url': `https://www.bungie.net/en/OAuth/Authorize?client_id=${CLIENT_ID}&response_type=code`,
				// 			'interactive': true
				// 		},
				// 		function (redirect_url) {
				// 			if (chrome.runtime.lastError) {
				// 				console.log(chrome.runtime.lastError);
				// 			} else {
				// 				let searchString = new URLSearchParams(redirect_url.split("?")[1]);
				// 				let code = searchString.get("code");
				// 				bungie.refreshAccessToken({
				// 					authCode: code
				// 				}).then(resolve);
				// 			}
				// 		});
				// } else {
				window.open(`https://www.bungie.net/en/OAuth/Authorize?client_id=${CLIENT_ID}&response_type=code`);
				localStorage.setItem('tabbed', true);
				localStorage.removeItem('authorization');
				window.addEventListener("storage", function (event) {
					let authorization = localStorage.getItem('authorization');
					if (localStorage.getItem('tabbed') && authorization) {
						authorization = JSON.parse(authorization);

						console.log('Authorization', authorization);

						localStorage.removeItem('tabbed');
						bungie.refreshAccessToken({
							authCode: authorization.code
						}).then(resolve);
					}
				});
				// }
			} else {
				resolve();
			}
		});
	};

	bungie.auth = function bungieAuth() {
		return new Promise(function (resolve) {
			if (!localStorage.bungieAuth) {
				localStorage.setItem('tabbed', true);
				localStorage.removeItem('authorization');
				console.log(`Opening a tab to https://www.bungie.net/en/OAuth/Authorize?client_id=${CLIENT_ID}&response_type=code`);

				window.open(`https://www.bungie.net/en/OAuth/Authorize?client_id=${CLIENT_ID}&response_type=code`);
				window.addEventListener("storage", function (event) {
					console.log(event)
					let authorization = localStorage.getItem('authorization');
					if (localStorage.getItem('tabbed') && authorization) {
						authorization = JSON.parse(authorization);

						console.log('Authorization', authorization);
						localStorage.removeItem('authorization');
						localStorage.removeItem('tabbed');
						bungie.refreshAccessToken({
							authCode: authorization.code
						}).then(bungie.validateTokens).then(resolve);
					}
				});
			} else {
				bungie.validateTokens().then(resolve);
			}
		});
	};

	function networkRequest(opts) {
		bungie.validateTokens().then(function () {
			_request(opts);
		});
	}

	bungie.getBungieNetAccounts = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/User/GetMembershipsById/${localTokens.membershipId}/${membershipType.bungie}/`,
				shortRoute: '/User/GetMembershipsById/',
				incomplete: reject,
				complete: resolve
			});
		});
	};
	// https://bungie-net.github.io/multi/schema_Destiny-DestinyComponentType.html#schema_Destiny-DestinyComponentType
	// Profiles: 100, ProfileInventories: 102, ProfileCurrencies: 103, Characters: 200, CharacterInventories: 201, CharacterProgressions: 202, CharacterEquipment: 205, ItemInstances: 300, ItemObjectives: 301, ItemPerks: 302
	bungie.getFullDestinyProfile = function (account) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny2/${account.membershipType}/Profile/${account.membershipId}/?components=100,102,103,200,201,202,204,205,300,301,302,500`,
				shortRoute: '/Destiny2/Profile/',
				method: 'GET',
				noerror: true,
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getDestinyProfileWithCharacters = function (account) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny2/${account.membershipType}/Profile/${account.membershipId}/?components=100,200`,
				shortRoute: '/Destiny2/Profile/',
				method: 'GET',
				noerror: true,
				incomplete: reject,
				complete: resolve
			});
		});
	};


	bungie.getAccountSummary = function (destinyMembership) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				destiny1: true,
				route: `/Destiny/${destinyMembership.membershipType}/Account/${destinyMembership.membershipId}/Summary/`,
				shortRoute: '/Destiny/Account/Summary/',
				method: 'GET',
				noerror: true,
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getActivityHistory = function (membershipType, membershipId, characterId, count, page) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny2/${membershipType}/Account/${membershipId}/Character/${characterId}/Stats/Activities/?count=${count}&mode=5&page=${page}`,
				shortRoute: '/Destiny2/Account/Character/Stats/Activities/',
				method: 'GET',
				noerror: true,
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getPGCR = function (activityId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny2/Stats/PostGameCarnageReport/${activityId}/`,
				shortRoute: '/Destiny2/Stats/PostGameCarnageReport/',
				method: 'GET',
				noerror: true,
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getProgression = function (destinyMembership) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				destiny1: true,
				route: `/Destiny/${destinyMembership.membershipType}/Account/${destinyMembership.membershipId}/Character/${destinyMembership.characterId}/Progression/`,
				shortRoute: '/Destiny/Account/Character/Progression/',
				method: 'GET',
				incomplete: reject,
				complete: function (response) {
					response.identifier = destinyMembership.identifier;
					response.type = "progression";
					resolve(response);
				}
			});
		});
	};

	bungie.getInventory = function (destinyMembership) {
		return new Promise(function (resolve, reject) {
			if (destinyMembership.characterId === "vault") {
				networkRequest({
					destiny1: true,
					route: `/Destiny/${destinyMembership.membershipType}/MyAccount/Vault/`,
					shortRoute: '/Destiny/MyAccount/Vault/',
					incomplete: reject,
					complete: function (response) {
						response.identifier = destinyMembership.identifier;
						response.type = "vault";
						resolve(response);
					}
				});
			} else {
				networkRequest({
					destiny1: true,
					route: `/Destiny/${destinyMembership.membershipType}/Account/${destinyMembership.membershipId}/Character/${destinyMembership.characterId}/Inventory/`,
					shortRoute: '/Destiny/Account/Character/Inventory/',
					incomplete: reject,
					complete: function (response) {
						response.identifier = destinyMembership.identifier;
						response.type = "inventory";
						resolve(response);
					}
				});
			}
		});
	};

	function recursive(index, array, networkTask, resultTask, endRecursion) {
		let self = this;
		if (array[index]) {
			new Promise(function (resolve) {
				// console.time("sequence")
				networkTask(array[index], resolve, index);
			}).then(function (result) {
				// console.timeEnd("sequence")
				if (typeof resultTask === "function") {
					resultTask(result, array[index], index);
				}
				self.recursive(index + 1, array, networkTask, resultTask, endRecursion);
			});
		} else {
			endRecursion();
		}
	}

	function sequence(array, networkTask, resultTask) {
		let self = this;
		return new Promise(function (resolve) {
			self.recursive(0, array, networkTask, resultTask, resolve);
		});
	}

	bungie.getCurrentBungieAccount = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/User/GetMembershipsById/${localTokens.membershipId}/${membershipType.bungie}/`,
				shortRoute: '/User/GetMembershipsById/',
				incomplete: reject,
				complete: function (response) {
					sequence(response.destinyMemberships, function (destinyAccount, complete) {
						ACTIVE_TYPE = destinyAccount.membershipType;
						MEMBERSHIP_ID = destinyAccount.membershipId;
						systemDetails[ACTIVE_TYPE] = {
							displayName: destinyAccount.displayName,
							membershipId: MEMBERSHIP_ID,
							membershipType: ACTIVE_TYPE,
							dateLastPlayed: null,
							characters: null
						};
						bungie.accountInfo().then(complete);
					}, function () {}).then(function () {
						if (localStorage.getItem("activePlatform") === null) {
							localStorage.activePlatform = 2;
						}
						if (parseInt(localStorage.activePlatform) === 2 && systemDetails[2]) {
							ACTIVE_TYPE = 2;
						} else if (parseInt(localStorage.activePlatform) === 1 && systemDetails[1]) {
							ACTIVE_TYPE = 1;
						} else if (parseInt(localStorage.activePlatform) === 2 && systemDetails[1]) {
							ACTIVE_TYPE = 1;
							localStorage.activePlatform = 1;
						} else if (parseInt(localStorage.activePlatform) === 1 && systemDetails[2]) {
							ACTIVE_TYPE = 2;
							localStorage.activePlatform = 2;
						}
						if (systemDetails[ACTIVE_TYPE]) {
							MEMBERSHIP_ID = systemDetails[ACTIVE_TYPE].membershipId;
						}
						resolve(response);
					});
				}
			});
		});
	};

	bungie.accountInfo = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Summary/',
				shortRoute: '/Destiny/Account/Summary/',
				method: 'GET',
				incomplete: reject,
				complete: function (response) {
					let flattenedCharacters = [];
					for (let character of response.data.characters) {
						let flatCharacter = {
							characterId: character.characterBase.characterId,
							classHash: character.characterBase.classHash,
							classType: character.characterBase.classType,
							currentActivityHash: character.characterBase.currentActivityHash,
							dateLastPlayed: character.characterBase.dateLastPlayed,
							emblemHash: character.emblemHash,
							emblemPath: character.emblemPath,
							genderHash: character.characterBase.genderHash,
							genderType: character.characterBase.genderType,
							isPrestigeLevel: character.isPrestigeLevel,
							level: character.characterLevel,
							membershipId: character.characterBase.membershipId,
							membershipType: character.characterBase.membershipType,
							percentToNextLevel: character.percentToNextLevel,
							powerLevel: character.characterBase.powerLevel,
							raceHash: character.characterBase.raceHash
						};
						flattenedCharacters.push(flatCharacter);
						if (systemDetails[ACTIVE_TYPE].dateLastPlayed === null || new Date(flatCharacter.dateLastPlayed).getTime() > new Date(systemDetails[ACTIVE_TYPE].dateLastPlayed).getTime()) {
							systemDetails[ACTIVE_TYPE].dateLastPlayed = flatCharacter.dateLastPlayed;
						}
					}
					systemDetails[ACTIVE_TYPE].characters = flattenedCharacters;
					resolve(response);
				}
			});
		});
	};

	bungie.activity = function (characterId, gameMode, count, page) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/Stats/ActivityHistory/' + ACTIVE_TYPE + '/' + MEMBERSHIP_ID + '/' + characterId + "/?mode=" + gameMode + "&count=" + count + "&page=" + page,
				shortRoute: '/Destiny/Stats/ActivityHistory/',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.vault = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/MyAccount/Vault/',
				shortRoute: '/Destiny//MyAccount/Vault/',
				incomplete: reject,
				complete: function (result) {
					resolve(result);
				}
			});
		});
	};

	bungie.inventory = function (characterId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Character/' + characterId + '/Inventory/?definitions=false',
				shortRoute: '/Destiny//Account//Character//Inventory/?definitions=false',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.inventory2 = function (characterId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Character/' + characterId + '/Complete/?definitions=false',
				shortRoute: '/Destiny//Account//Character//Inventory/?definitions=false',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.carnage = function (activityId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/Stats/PostGameCarnageReport/' + activityId + '/?definitions=false',
				shortRoute: '/Destiny/Stats/PostGameCarnageReport//?definitions=false',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.advisorsForAccount = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Advisors/?definitions=false',
				shortRoute: '/Destiny/Account/Advisors/',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.factions = function (characterId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Character/' + characterId + '/Progression/?definitions=false',
				shortRoute: '/Destiny//Account//Character//Progression/?definitions=false',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.advisorsForCharacter = function (characterId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/' + ACTIVE_TYPE + '/Account/' + MEMBERSHIP_ID + '/Character/' + characterId + '/Advisors/V2/?definitions=false',
				shortRoute: '/Destiny//Account//Character//Progression/?definitions=false',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.statsForAccount = function (characterId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny/Stats/Account/${ACTIVE_TYPE}/${MEMBERSHIP_ID}/`,
				shortRoute: '/Destiny/Stats/Account/{membershipType}/{destinyMembershipId}/',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getVendorForCharacter = function (characterId, vendorId, ignoreCache) {
		return new Promise(function (resolve, reject) {
			let data = localStorage.getItem(vendorId + "-" + characterId);
			if (data) {
				data = JSON.parse(data);
			}
			if (ignoreCache || !data || moment(data.nextRefreshDate).isBefore(moment()) || moment(data.nextRefreshDate).format("YYYY") === "9999") {
				networkRequest({
					route: `/Destiny/${ACTIVE_TYPE}/MyAccount/Character/${characterId}/Vendor/${vendorId}/Metadata/`,
					shortRoute: '/Destiny//MyAccount/Character//Vendor//Metadata/',
					noerror: true,
					incomplete: reject,
					complete: function (bungieResult) {
						if (bungieResult.data) {
							if (moment(bungieResult.data.vendor.nextRefreshDate).format("YYYY") === "9999" || moment(bungieResult.data.vendor.nextRefreshDate).isBefore(moment())) {
								bungieResult.data.vendor.nextRefreshDate = moment().add(1, "days").format("YYYY-MM-DDTHH:mm:ssZ");
							}
							bungieResult.data.vendor.vendorCharacterHash = vendorId + "-" + characterId;
							localStorage.setItem(vendorId + "-" + characterId, JSON.stringify(bungieResult.data.vendor));
							resolve(bungieResult.data.vendor);
							// database.addSingle("vendors", bungieResult.data.vendor).then(resolve);
						} else { // Vendor not found
							resolve(bungieResult);
						}
					}
				});
			} else {
				resolve(data);
			}
		});
	};

	bungie.getXur = function () {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: `/Destiny/Advisors/Xur/?definitions=false`,
				shortRoute: '/Destiny/Advisors/Xur/',
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.transfer = function (characterId, itemId, itemReferenceHash, stackSize, transferToVault) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/TransferItem/',
				shortRoute: '/Destiny/TransferItem/',
				noerror: true,
				payload: {
					characterId: characterId,
					membershipType: ACTIVE_TYPE,
					itemId: itemId,
					itemReferenceHash: itemReferenceHash,
					stackSize: stackSize,
					transferToVault: transferToVault
				},
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.lock = function (characterId, instanceId) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: '/Destiny/SetLockState/',
				shortRoute: '/Destiny/SetLockState/',
				noerror: true,
				payload: {
					characterId: characterId,
					membershipType: ACTIVE_TYPE,
					itemId: instanceId,
					state: true
				},
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.query = function (route) {
		return new Promise(function (resolve, reject) {
			networkRequest({
				route: route,
				shortRoute: route,
				incomplete: reject,
				complete: resolve
			});
		});
	};

	bungie.getCurrentAccount = function () {
		return systemDetails[ACTIVE_TYPE];
	};

	bungie.destinyMembershipId = function () {
		return MEMBERSHIP_ID;
	};

	bungie.membershipType = function () {
		return ACTIVE_TYPE;
	};

	bungie.ready = function () {
		return ACTIVE_TYPE !== 0 && MEMBERSHIP_ID !== "" && typeof systemDetails[ACTIVE_TYPE] !== "undefined";
	};

	bungie.getMemberships = function () {
		return Object.keys(systemDetails);
	};

	bungie.clearCache = function () {
		requestCache = {};
	};

	return bungie;
}());

if (typeof window !== "undefined") {
	window.bungie = bungie;
}

export default bungie


// WEBPACK FOOTER //
// ./src/shared/bungie.js